import React from 'react';
import classes from './ResourceProperty.module.scss';
import { resourceHelpers } from '@/utils/helpers';
import capitalize from 'lodash/capitalize';
import t from '@/utils/Language/ResourceCard-translations';
import { isObject } from '@/utils/utils';

const ResourceProperty = ({ name, value }, ...props) => {
  return (
    <>
      <div className={classes.label}>{capitalize(t(name))}</div>
      <div className={classes.value}>
        {Array.isArray(value) &&
          value.map((val, index) => {
            let specialCaseProp = ['resident-of', 'age-elig', 'grade-elig', 'child-elig', 'income-elig'].filter(
              (prop) => val.indexOf('[' + prop + ']') === 0
            );
            if (specialCaseProp.length) {
              return (
                <span key={index}>
                  {capitalize(t(specialCaseProp[0]) + t(val.replace('[' + specialCaseProp[0] + ']', ''))) + (index == value.length - 1 ? '' : ', ')}
                </span>
              );
            } else {
              return <span key={index}>{capitalize(t(val)) + (index == value.length - 1 ? '' : ', ')}</span>;
            }
          })}
        {typeof value === 'string' ? t(value) : null}
        {isObject(value) ? resourceHelpers.propertyRange(value) : null}
      </div>
    </>
  );
};

export default ResourceProperty;
